(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.FIGSymposium",
                {
                    url: "/FIGSymposium",
                    component: "figSymposium",
                    PageTitle: "FIG Symposium 2019",
                    requiredPermissions: "FigSymposium:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("figSymposium",
        {
            templateUrl: "App/Resources/FIGSymposium/figSymposium.html",
            controller: figSymposiumCtrl,
            bindings: {
                states: "<"
            }
        });

    figSymposiumCtrl.$inject = ["$http", "surveys", "permissionService", "iComplySettings", "iComplyApi"];

    function figSymposiumCtrl($http, surveys, permissionService, iComplySettings, iComplyApi) {
        var $ctrl = this;
       
    }
})(window.app, window.angular); // jshint ignore:line